import _ from 'underscore';
import WebsiteHome from '../../html/coxfootball2021/website.html';
import '../../scss/arcade/coxFootball2024.scss';
import Arcade from '../engine/arcade/arcade';
import Home from '../engine/home/home';
import { capitalize, getSearchParam } from '../util/utilities';

// TODO Do we need these this year?
// Maze Tile Maps
import '../../json/tilemaps/TileSet_1Character_1Pickup_64x64.json';
import '../../json/TileSet1_64x64.json';

const utmCampaign = getSearchParam('utm_campaign') || '';
const utmMedium = getSearchParam('utm_medium') || '';

const campaign = utmCampaign.replace('coxFootball2024', '');
const arcadeName = `CoxFootball2024${campaign}`;

const contentVersion = `${capitalize(campaign)}${capitalize(utmMedium)}`;
const contentUrl = encodeURI(`/coxFootball2024/json/arcadeData${contentVersion}.json`);

const arcade = new Arcade({ arcadeName, contentUrl });
arcade.arcadeState.on('change', () => {
	// Handle microsite specific data and template
	if (/microsite/i.test(campaign)) {
		const pages = arcade.arcadeState.get('pages');
		const homeData = pages.find((page) => page.type === 'home');

		if (!homeData) {
			this.logger.error('Missing microsite home data');
			return;
		}

		// Map section.pages to page data
		homeData.sections.forEach((section) => {
			section.pages = section.pages?.map((pageId) => pages.find(({ id }) => id === pageId));
		});

		// Create custom engine with unique template
		homeData.engine = class MicrositeHome extends Home {
			get template() {
				return _.template(WebsiteHome);
			}

			render() {
				this.logger.log('[render]');

				const { sections, bgVideoUrl } = this;
				this.$el.empty().append(this.template({ sections, bgVideoUrl }));
			}
		};
	}
});
